export default __webpack_public_path__ + "static/media/06.4e0c3151.png";